import { useState } from 'react';
import ReactDOM from 'react-dom';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Modal from '@Components/Shared/Modals/Modal';
import translator from '@Components/Utilities/Translator';
import { webSavedSearchNameCharCountLimit } from '@Components/Utilities/SandhillsConstants';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const CustomWatchlistModal = (props) => {
    const windowSize = useWindowSize();
    const routes = useRecoilValue(atoms.routes);

    const onClose = () => {
        props?.onClose?.();
    };
    const [watchlistName, setWatchlistName] = useState(props.watchlistName);
    const [message, setMessage] = useState('');
    const [messageClass, setMessageClass] = useState('');
    const [submitDisabled, setSubmitDisabled] = useState(false);

    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substr(0, maxLength);
    };
    const onKeyPress = (e) => {
        if (e.key === 'Enter') {
            saveWatchlist(watchlistName);
        }
    };

    const textboxStyles = {
        fontSize: '16px',
        marginLeft: '10px'
    };

    const buttonStyles = {
        fontWeight: '700'
    };

    const saveWatchlist = () => {
        setSubmitDisabled(true);
        if (props.CustomWatchlists?.find(x => x.ListName.toLowerCase().trim() === watchlistName.toLowerCase().trim())) {
            setMessage('A watchlist with the same name has already been added.');
            setMessageClass('message-error');
            setSubmitDisabled(false);
        } else if (!watchlistName) {
            setMessage('Please enter a name for your watchlist');
            setMessageClass('message-error');
            setSubmitDisabled(false);
        } else {
            sandhillsRequest({
                url: routes.SaveCustomWatchlist,
                method: 'post',
                data: {
                    "listingId": props.Id,
                    "name": watchlistName
                }
            }).then((result) => {
                if (result) {
                    setMessage(translator.translate('sandhills.success'));
                    setMessageClass('message');
                    setTimeout(() => { props.onClose(); window.location.reload(); setSubmitDisabled(false); }, 1500);
                } else {
                    setMessage(translator.translate('sandhills.error'));
                    setMessageClass('message-error');
                    setSubmitDisabled(false);
                }
            });
        }
    };

    const modalContent = (
        <Modal containerClassName='buyers-premium-modal watchlist-modal' contentClassName={windowSize.isMobile ? 'mobile-saved-searches' : ''} onEscapeKeyClose={onClose}>
            <Modal.Header onClose={props.onClose}>{translator.translate('sandhills.createnewwatchlist')}</Modal.Header>
            <Modal.Body>
                <label htmlFor='watchlist-name' >{translator.translate('sandhillssystem.watchlistname')}</label>
                <span className={messageClass}>{message}</span>
                <TextField id="watchlist-name" variant="standard"
                    className='saved-searches__save-current-text-input'
                    inputProps={{ style: { ...textboxStyles } }}
                    sx={{ width: '100%', 'border-bottom': 'none' }}
                    InputLabelProps={{ className: 'visually-hidden', shrink: true }}
                    value={watchlistName}
                    onChange={(e) => setWatchlistName(truncateText(e.target.value, webSavedSearchNameCharCountLimit))}
                    onKeyPress={onKeyPress} />
                <div style={{ 'margin-top': '25px' }}>
                    <Button className='save-button' variant="contained" sx={buttonStyles} onClick={saveWatchlist} disabled={submitDisabled}>{translator.translate('sandhillssystem.save')}</Button>
                    <a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); props.onClose(); } }} onClick={props.onClose} className='cancel-button'>{translator.translate('sandhills.cancel')}</a>
                </div>
            </Modal.Body>
        </Modal>
    );

    return props.usePortal ? ReactDOM.createPortal(modalContent, document.getElementById(props.DomNode)) : modalContent;
}

export default CustomWatchlistModal;